import type { HasBodyProps } from './types'

export const hasBody = ({
  showDates,
  showTimelineTime,
  dateFrom,
  comment,
  reminder,
  children,
}: HasBodyProps): boolean => Boolean(showDates || showTimelineTime || dateFrom || comment || reminder || children)
